import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Checkbox } from "@/components/ui/checkbox";
import { ShieldCheck } from "lucide-react";

const SCREENS = [["overview", "Overview"], ["inventory", "Inventory"], ["sales", "Sales"], ["purchases", "Purchase"], ["sell", "Sell & Estimate"], ["rto", "RTO"], ["targets", "Targets"], ["tasks", "Tasks"]];

export const AccessRights = () => {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/auth/whitelist").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const toggle = async (row, screen) => {
    const next = row.screens.includes(screen) ? row.screens.filter((s) => s !== screen) : [...row.screens, screen];
    setRows((rs) => rs.map((r) => (r.id === row.id ? { ...r, screens: next } : r)));
    try {
      await api.put(`/auth/whitelist/${row.id}/screens`, { screens: next });
      toast.success(`${row.name || row.email} — access updated`);
    } catch { toast.error("Could not save"); load(); }
  };

  return (
    <div data-testid="access-rights" className="bg-[#1E293B] border border-[#334155] rounded-lg p-5">
      <h3 className="text-lg font-semibold mb-1 flex items-center gap-2" style={{ fontFamily: "Outfit, sans-serif" }}>
        <ShieldCheck className="h-5 w-5 text-blue-400" /> Screen Access Rights
      </h3>
      <p className="text-xs text-slate-400 mb-3">Tick which screens each employee can open. Their first ticked screen becomes their landing page. New employees get Sell & Estimate + Targets by default. You (admin) always see everything.</p>
      <div className="overflow-x-auto">
        <table className="w-full text-sm whitespace-nowrap">
          <thead>
            <tr className="text-left text-[9px] uppercase tracking-widest text-slate-400 border-b-2 border-[#334155]">
              <th className="pb-2 pr-3">Employee</th>
              {SCREENS.map(([, l]) => <th key={l} className="pb-2 px-2 text-center">{l}</th>)}
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id} data-testid={`access-row-${row.email}`} className="border-b border-slate-800/60">
                <td className="py-2.5 pr-3">
                  <span className="font-semibold text-slate-200">{row.name || row.email}</span>
                  {row.name && <span className="block text-[10px] text-slate-500">{row.email}</span>}
                </td>
                {SCREENS.map(([v]) => (
                  <td key={v} className="py-2.5 px-2 text-center">
                    <Checkbox data-testid={`access-${row.email}-${v}`} checked={row.screens.includes(v)} onCheckedChange={() => toggle(row, v)}
                      className="border-slate-600 data-[state=checked]:bg-blue-600 data-[state=checked]:border-blue-600" />
                  </td>
                ))}
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={8} className="py-5 text-center text-xs text-slate-500">No employees whitelisted yet — add them below.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
};
